import { useRouter } from 'next/router';
import React, { FC, useEffect } from 'react';

import PageLoader from '~/shared/components/PageLoader';

import { OVERVIEW_ROUTE } from '../constants/routes';
import { useAuth } from '../contexts/AuthContext';

const UnauthenticatedPage: FC = ({ children }) => {
  const { replace, query } = useRouter();
  const { isReady, accessToken } = useAuth();

  useEffect(() => {
    if (isReady && accessToken) {
      replace(
        (query.redirectTo as string) || {
          pathname: OVERVIEW_ROUTE,
        }
      );
    }
  }, [isReady, query.redirectTo, replace, accessToken]);

  return !isReady || accessToken ? <PageLoader /> : <>{children}</>;
};

export default UnauthenticatedPage;
